import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { dateUtils } from '@bringg-frontend/utils';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import styles from './progress-bar-section.module.scss';

interface CapacityUtilizationCardHeaderProps {
	iconName: BringgFontIcons;
	label?: string;
	availableSeconds?: number;
}

export const CapacityUtilizationHeader = ({
	iconName,
	label,
	availableSeconds
}: CapacityUtilizationCardHeaderProps) => {
	const { t } = useTranslation();
	return (
		<div className={styles.capacityUtilizationHeader}>
			<div className={styles.left}>
				<BringgIcon iconName={iconName} />
				{label && (
					<span className={classNames(styles.label, { [styles.labelOffset]: availableSeconds == null })}>
						{label}
					</span>
				)}
			</div>
			{availableSeconds != null && (
				<span className={styles.availableBadge}>
					{dateUtils.formatDuration(availableSeconds)}{' '}
					{t('PLANNED_DELIVERY_WINDOWS_POPOVER_CONTENT.PROGRESS_BAR.AVAILABLE')}
				</span>
			)}
		</div>
	);
};
